import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class QuickUpdatesServices {
  // Quick Update
  quickUpdateEntityWise = async (payload) => {
    const quickUpdate = await Helpers.put({
      url: Constants.QUICK_UPDATE_ENTITY_WISE,
      data: payload,
    });
    return quickUpdate;
  }
}

export default new QuickUpdatesServices();
